<template>
	<div>
		<b-modal
			id="fetch-modal"
			header-class="bg-sinarmas"
			size="md"
			no-close-on-backdrop
			hide-footer
			@hide="closeFetch"
		>
			<template v-slot:modal-header="{ close }">
				<div class="w-100 d-flex align-items-center justify-content-between">
					<span class="text-white font-weight-bold">Error</span>

					<a @click.prevent="close" href="javascript:void(0);" class="btn btn-transparent"><i class="material-icons font-weight-bold text-white" style="font-size: 18px; vertical-align: middle;">close</i></a>
				</div>
			</template>
			<div>Supplier Not Found</div>
	  </b-modal>
	</div>
</template>

<script>
import {filterCategory} from '../store/data'
export default {
	name: 'Fetch',
	data() {
		return {
			selectedFilters: [],
			itemToFilter: null,
		}
	},
	methods: {
		closeFetch(){
			this.$store.dispatch('datatable/toggleModalFetch')
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~/assets/scss/components/filter-setting.scss';
</style>
